import { useSplit } from '@buffer-mono/features'

import { useAccountId } from '~publish/contexts/AccountContext'

/**
 * Hook to check if the current user can manage changelog entries.
 * Uses account ID for the split check instead of org ID.
 */
export function useIsChangelogManager(): {
  canManage: boolean
  isReady: boolean
} {
  const accountId = useAccountId()

  const options = accountId
    ? { splitKey: accountId, trafficType: 'user' as const }
    : undefined

  const { split, isReady } = useSplit('changelog-entries', options)

  return {
    canManage: split.treatment === 'on',
    isReady,
  }
}
